
import _ from 'lodash'
import React from 'react'
import { connect } from 'react-redux'

import { phoneToFhir } from '../../lib/Proxy/lib/phone'
import CrudTable from '../shared/CrudTable'
import ConfirmationDeleteDialog from '../shared/DeleteDialog/ConfirmationDeleteDialog'
import {
  bindTargetMixin,
  CancelButton,
  CheckboxInput,
  Fieldset,
  SaveButton,
  TextInput,
  Validators,
  MaskedTextInput
} from '../shared/FormBuilder'
import { Paper, ErrorMessage } from '../shared/NarusMaterial'

import { getExternalRecivers } from './actions'
import './styles.scss'

const mapStateToProps = redux => ({
  receivers: _.get(redux, 'admin.externalReceivers', []),
  clients: _.get(redux, 'globalVars.clients', [])
})

class UserForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount () {
    const {
      value: { clientRoles }
    } = this.state

    this.setState(state => ({
      ...state,
      isExtendedDataLoading: true
    }))

    if (!clientRoles || clientRoles.length === 0) {
      this.setState(state => ({
        ...state,
        value: {
          ...state.value,
          clientRoles: [{}]
        }
      }))
    }
  }

  getValue () {
    return { ...this.state.value }
  }

  handleSubmit () {
    const { onSubmit } = this.props
    onSubmit(this.getValue())
  }

  render () {
    const {
      value: { id }
    } = this.state
    const { error, clients } = this.props

    const clientsCheckboxes = _.sortBy(clients, 'display').map(client => (
      <div
        className='col-xs-3'
        key={client.clientName}
      >
        <CheckboxInput
          className='admin_receive_checkbox'
          label={client.display}
          name={client.clientName}
        />
      </div>
    ))

    return (
      <form onSubmit={this.handleSubmit}>
        <Paper>
          {error && (
            <div className='row'>
              <div className='col-xs-12'>
                <ErrorMessage
                  errors={error && [ error ]}
                  style={{
                    fontSize: '14px',
                    marginBottom: '0.5rem'
                  }}
                />
              </div>
            </div>
          )}
          <div className='row'>
            <div className='col-xs-12 col-sm-4 col-md-4'>
              <TextInput
                label='Name'
                name='name'
                required
              />
            </div>
            <div className='col-xs-12 col-sm-12 col-md-12'>
              <TextInput
                label='Email'
                name='email'
                validators={[ Validators.email() ]}
              />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-6'>
              <MaskedTextInput
                mask='111.111.1111'
                name='fax'
                label='Fax'
                validators={[ Validators.phone() ]}
                helperText='Fax number'
              />
            </div>
          </div>

          <Fieldset name='clients'>
            <div
              className='row'
              style={{ marginTop: '20px' }}
            >
              {clientsCheckboxes}
            </div>
          </Fieldset>

          <div
            style={{
              marginTop: '20px',
              display: 'flex'
            }}
          >
            <div
              style={{
                flexGrow: '1',
                color: '#d6d6d6',
                paddingTop: '10px'
              }}
            >
              Receiver ID:
              {' '}
              {id}
            </div>
            <CancelButton
              noGlobal
              onClick={this.props.onCancel}
            />
            <SaveButton
              onClick={this.handleSubmit}
              disabled={false}
            />
          </div>
        </Paper>
      </form>
    )
  }
}

const formatPhoneNumber = number => {
  if (_.isNil(number)) {
    return
  }
  const trimmed = value => value.replace(/\D/g, '')
  const last10 = value => value.slice(-10)
  const formatted = value =>
    value.replace(/^(\d{3})(\d{3})(\d{4}).*/, '$1.$2.$3')

  return formatted(last10(trimmed(number)))
}

class Receivers extends React.Component {
  UNSAFE_componentWillMount () {
    const { dispatch } = this.props
    dispatch(getExternalRecivers())
  }

  render () {
    const { receivers, clients } = this.props
    const spec = {
      type: 'External Recipient',
      form: UserForm,
      urls: {
        get: () => '/admin/receivers',
        create: () => '/admin/receivers',
        update: entry => `/admin/receivers?id=${entry.id}`,
        delete: entry => `/admin/receivers?id=${entry.id}`
      },
      mapFns: {
        toForm: user => ({
          // originalUser: { ...user },
          id: _.get(user, 'id'),
          name: _.get(user, 'name'),
          email: _.get(user, 'email'),
          fax: _.chain(user).get('fax', '').split('+1').last()
            .value(),
          clients: _.get(user, 'clients')
        }),
        toFhir: user => {
          const originalUser = user.originalUser || {}
          return {
            ...originalUser,
            id: user.id,
            name: user.name,
            fax: user.fax && `${phoneToFhir(user.fax)}`,
            email: user.email,
            clients: user.clients
          }
        }
      },
      table: [
        {
          title: 'Name',
          displayFn: x => x.name
        },
        {
          title: 'Email',
          displayFn: x => x.email
        },
        {
          title: 'Fax',
          displayFn: x => formatPhoneNumber(x.fax)
        }
      ]
    }

    return (
      <div>
        <h1><b>External Recipients</b></h1>
        <CrudTable
          labelButton='Recipient'
          labelNoEntries='External Recipients'
          urlFns={spec.urls}
          entryType={spec.type}
          tableDefinition={spec.table}
          mapFns={spec.mapFns}
          form={spec.form}
          additionalFormProps={{
            receivers,
            clients
          }}
          deleteDialog={ConfirmationDeleteDialog}
          noDelete={false}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps)(Receivers)
